module.exports = __webpack_public_path__ + "img/hand.6a3d994f.svg";